import clsx from 'clsx';
import React, { forwardRef } from 'react';

import * as styles from './tag.styles';
import { Element } from '../element';
import { Icon } from '../icon';

/** @type {import(".").TagType} */
const Tag = forwardRef(({ className, children, onClose, isInteractive, disabled, ...props }, ref) => {
  const isInteractiveCalculated = (Boolean(onClose) || isInteractive) && !disabled;
  const onKeyDownHandler = (evt) => {
    if (isInteractiveCalculated && ['Space', 'Enter', 'NumpadEnter'].includes(evt.code)) {
      onClose(evt);
    }
    props.onKeyDown?.(evt);
  };
  return (
    <Element
      ref={ref}
      className={clsx(
        styles.tag,
        {
          [styles.variants.interactive]: isInteractiveCalculated,
        },
        className,
      )}
      tabIndex={isInteractiveCalculated ? 0 : -1}
      role={isInteractiveCalculated ? 'button' : undefined}
      {...props}
      disabled={disabled}
      onKeyDown={onKeyDownHandler}
    >
      <Element>{children}</Element>
      {onClose && (
        <Element className={styles.components.btnClose} disabled={disabled} onClick={isInteractiveCalculated ? onClose : undefined}>
          <Icon name="close" />
        </Element>
      )}
    </Element>
  );
});

if (process.env.NODE_ENV !== 'production') {
  Tag.displayName = 'Tag';
}

export default Tag;
